import { Dropdown, Menu, Tag } from "antd";

const UpdateDropDown = ({ handleStatusUpdate, record }) => {
  const menuItems = [
    { name: "Hard Document Received", value: "HARD_COPY_RECEIVED" },
    {
      name: "Document Submitted to Academic Office",
      value: "SUBMITTED_TO_ACADEMIC_OFFICE",
    },
    {
      name: "Hard copy ready for pickup",
      value: "HARD_COPY_READY",
    },
    {
      name: "Courier Pickup",
      value: "COURIER_PICKUP",
    },
    {
      name: "Document Delivered",
      value: "DOCUMENT_DELIVERED",
    },
  ];

  // const handleStatusUpdate = (value) => {
  //   console.log("value ", value);
  //   console.log("record ", record);
  // };
  const menu = (
    <Menu
      items={menuItems.map((item, index) => {
        return {
          key: index,
          label: (
            <a onClick={() => handleStatusUpdate(item.value)}>{item.name}</a>
          ),
        };
      })}
    />
  );
  return (
    <>
      <Dropdown
        overlay={menu}
        placement="bottom"
        arrow
        className="cursor-pointer"
      >
        <Tag color="blue">Update</Tag>
      </Dropdown>
    </>
  );
};

export default UpdateDropDown;
